import type { loadingToast } from '@side/pantry';

interface UserClaimsRole {
  id: string;
  name: string;
}
interface UserClaimsProfile {
  id: string;
  legacyExternalId: string;
  teams: string[];
  roles: UserClaimsRole[];
}

export type UserClaims = {
  id: string;
  legacyExternalId: string;
  profiles: UserClaimsProfile[];
};

export type LoadingToastMessages = Parameters<typeof loadingToast>[1];

export type FieldErrorConfig = {
  name: string;
  data: {
    type: string;
    message: string;
  };
};

// TODO: This really ought to be a generated type, but hard coding it here until there is
// a more maintainable delivery solution.
export enum Scopes {
  ADDRESSES_WRITE = 'addresses:write',
  BROKERAGES_CREATE = 'brokerages:create',
  BROKERAGES_DELETE = 'brokerages:delete',
  BROKERAGES_READ = 'brokerages:read',
  BROKERAGES_UPDATE = 'brokerages:update',
  TEAM_MEMBERS_ASSIGNMENTS_WRITE = 'teamMembers:assignments:write',
  TEAM_MEMBERS_CREATE = 'teamMembers:create',
  TEAM_MEMBERS_READ = 'teamMembers:read',
  TEAM_MEMBERS_UPDATE = 'teamMembers:update',
  TEAM_MEMBERS_DELETE = 'teamMembers:delete',
  TEAMS_CREATE = 'teams:create',
  TEAMS_DELETE = 'teams:delete',
  TEAMS_OFFICEMANAGER_WRITE = 'teams.officeManager:write',
  TEAMS_READ = 'teams:read',
  TEAMS_SUPERVISINGBROKER_WRITE = 'teams.supervisingBroker:write',
  TEAMS_UPDATE = 'teams:update',
  USERS_LICENSES_WRITE = 'users:licenses:write',
  USERS_LICENSES_DELETE = 'users:licenses:delete',
  USERS_READ = 'users:read',
  USERS_CREATE = 'users:create',
  USERS_UPDATE = 'users:update',
  USERS_SIGNATURE_READ = 'users:signature:read',
  EXTERNAL_SERVICES_READ = 'externalServices:read',
  EXTERNAL_SERVICES_WRITE = 'externalServices:write',
  MLS_READ = 'mls:read',
  MLS_WRITE = 'mls:write',
  MLS_DELETE = 'mls:delete',
  AOR_READ = 'aor:read',
  AOR_WRITE = 'aor:write',
  AOR_DELETE = 'aor:delete',
}

export enum AllowedImageFileExtensions {
  JPEG = 'jpeg',
  JPG = 'jpg',
  PNG = 'png',
  BMP = 'bmp',
  TIFF = 'tiff',
  WEBP = 'webp',
}
